<script lang="ts" setup>
	import StringMethods from '~/utils/character'

	const { type } = defineProps<{
		type: string
	}>()
	type SvgIcons = Record<string, { pathClass: string; icon: string; dir: string; bg: string }>
	const svgPathClass = computed<SvgIcons>(() => {
		return {
			activation: {
				pathClass: 'fill-blue-500',
				bg: 'bg-blue-100',
				dir: 'other',
				icon: 'shield'
			},
			'check-in': {
				dir: 'fill',
				bg: 'bg-orange-100',
				icon: 'people',
				pathClass: 'fill-orange-500'
			},
			consultation: {
				dir: 'fill',
				bg: 'bg-pink-100',
				icon: 'doctor',
				pathClass: 'fill-pink-500'
			},
			dependant: {
				dir: 'fill',
				bg: 'bg-purple-100',
				icon: 'hospital',
				pathClass: 'fill-purple-500'
			}
		}
	})
	const { toLower } = StringMethods()
	const statusType = computed(() => toLower(type))
</script>

<template>
	<div
		class="inline-flex h-[32px] w-[32px] flex-none items-center justify-center rounded-full"
		:class="svgPathClass?.[statusType]?.bg ?? 'bg-gray-100'"
	>
		<tools-icon
			:dir="svgPathClass?.[statusType]?.dir ?? 'fill'"
			:icon="svgPathClass?.[statusType]?.icon ?? 'mcg-cap'"
			:height="16"
			:path-class="svgPathClass?.[statusType]?.pathClass ?? ''"
		/>
	</div>
</template>
